import { useEffect, useRef } from 'react';

const replaceState = (queryParams) => {
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}?${queryParams.toString()}`,
  );
};

export default (location, locationIsModal) => {
  const isModalRef = useRef();
  const queryParams = new URLSearchParams(location.search);

  // Synchronously we replace the location to add/remove the query parameter
  if (locationIsModal) {
    // If previous wasn't modal, update URL so when going back we behave as expected
    if (!isModalRef.current && !queryParams.get('first_modal')) {
      queryParams.append('first_modal', true);

      replaceState(queryParams);
    }
  } else if (queryParams.get('first_modal')) {
    queryParams.delete('first_modal');

    replaceState(queryParams);
  }

  useEffect(() => {
    isModalRef.current = locationIsModal;
  }, [location]);

  // It can be first modal even if previously it was a modal
  // window.history.back would be this scenario
  // modal1 -> modal2 -> back -> modal1
  return queryParams.get('first_modal') || !isModalRef.current;
};
